import { useSessionStore } from "@features/session";
/* -----------------Helpers & Hooks--------------- */
import { useLocalSearchParams } from "expo-router";

import { isMockedData } from "@constants/demo";
import { mockedReportResponse } from "@constants/demo/";
import useAppConfigIds from "@hooks/useAppConfigIds";
import { useDemoExamStore } from "@hooks/useDemoExamStore";
/* -----------------Child components--------------- */
import { useQuery } from "@tanstack/react-query";
import { getReport } from "../api";
export const useReport = () => {
	const params = useLocalSearchParams<{
		id: string;
	}>();

	const id = params?.id;

	const isAnswerEventInProgress = useSessionStore(
		(state) => state.isAnswerEventInProgress,
	);

	const { userId } = useAppConfigIds();

	const demoExam = useDemoExamStore((state) => state.currentExam);

	const isEndingSessionInProgress = useSessionStore(
		(state) => state.isEndingSessionInProgress,
	);

	const { data: reportDetails } = useQuery({
		queryKey: ["report", id, userId],
		queryFn: async () => {
			if (isMockedData) {
				return mockedReportResponse(demoExam.id);
			}
			const reportDetails = await getReport({
				sessionId: Number(id),
				userId,
			});
			return reportDetails;
		},
		enabled:
			isMockedData ||
			(!(isAnswerEventInProgress || isEndingSessionInProgress) &&
				Boolean(id) &&
				Boolean(userId)),
	});

	return {
		reportDetails,
	};
};
